import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl" }
const _hoisted_3 = { class: "flex items-start justify-between gap-4" }
const _hoisted_4 = { class: "flex h-10 w-10 items-center justify-center rounded-full bg-red-100 text-red-600" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex-1 space-y-2 text-left" }
const _hoisted_7 = { class: "m-0 text-[1.5rem] font-semibold text-black" }
const _hoisted_8 = { class: "m-0 text-[1.3rem] text-[color:var(--gray)] whitespace-pre-line" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "mt-6 flex justify-end gap-3" }

import { ref, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useUIStore } from "@/stores/useUIStore";
import { GlobalErrors, NetworkError } from "@/enum/constants";
import ErrorAlertIcon from "@/assets/images/error-alert.svg";
import CloseIcon from "@/assets/images/close-small.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalError',
  setup(__props) {

const uiStore = useUIStore();
const router = useRouter();
const { t } = useI18n();

const errorMsg = ref("");
const openLogin = ref(false);
const errorIcon = ErrorAlertIcon;
const closeIcon = CloseIcon;

const isOpen = computed(() => uiStore.globalErrorIsOpen);
const errorData = computed(() => uiStore.globalErrorData);

watch(errorData, (newValue) => {
  if (uiStore.globalErrorOnlyPopup === true) {
    uiStore.setGlobalErrorData({});
    uiStore.openLogin();
    openLogin.value = false;
    return;
  }
  if (newValue && Object.keys(newValue).length > 0) {
    manageError(newValue);
  }
});

function close() {
  uiStore.setGlobalErrorData({});
  uiStore.setGlobalErrorCode(null);
  uiStore.closeGlobalError();
  if (uiStore.globalErrorRedirectUrl != null) {
    router.push(uiStore.globalErrorRedirectUrl);
    uiStore.setGlobalErrorRedirectUrl(null);
    return;
  }
  if (openLogin.value) {
    openLogin.value = false;
    uiStore.openLogin();
  }
}

function manageError(error: Record<string, unknown>) {
  const resp = error.response as Record<string, unknown> | undefined;
  const status = resp?.status as number | undefined;
  switch (status) {
    case -1:
      errorMsg.value = resp?.message as string ?? "";
      break;
    case GlobalErrors.ERROR_400: {
      const msgs = (resp?.data as Record<string, unknown>)?.messages as string[] | undefined;
      errorMsg.value = msgs?.[0] ?? t("sorry_we_are_having_problems_please_try_again_later");
      break;
    }
    case GlobalErrors.ERROR_500: {
      const data = resp?.data as Record<string, unknown> | string | undefined;
      const msgs = typeof data === "object" ? (data as Record<string, unknown>)?.messages as string[] | undefined : undefined;
      if (msgs?.[0]) {
        errorMsg.value = msgs[0];
      } else if (
        (error as Record<string, unknown>).code === NetworkError.ABORTED ||
        (error as Record<string, unknown>).message?.toString().includes(NetworkError.NET) ||
        (typeof data === "string" && data.includes(NetworkError.PROXY))
      ) {
        uiStore.setGlobalErrorRedirectUrl("/DisconnectError");
        close();
      }
      errorMsg.value = t("sorry_we_are_having_problems_please_try_again_later");
      break;
    }
    default:
      errorMsg.value = t("sorry_we_are_having_problems_please_try_again_later");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _unref(errorIcon),
                    alt: "",
                    class: "h-6 w-6"
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('There was a problem')), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(errorMsg.value), 1)
                ]),
                _createElementVNode("button", {
                  class: "text-black/60 hover:text-black",
                  "aria-label": "Close",
                  onClick: close
                }, [
                  _createElementVNode("img", {
                    src: _unref(closeIcon),
                    alt: "",
                    class: "h-5 w-5"
                  }, null, 8, _hoisted_9)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "rounded-xl border border-black/10 px-4 py-2 text-[1.3rem] text-black hover:border-black/30",
                  onClick: close
                }, _toDisplayString(_ctx.$t('Close')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})